<template>
  <section id="main" class="main-viewport">
    <div class="subpage-banner py-4 img-only" style="background-image:url('images/banners/subpage-banner.jpg');">
      &nbsp;
    </div>
    <div class="subpage-content content-wrap mh-auto">
      <div class="container py-4 text-container">
        <div class="row no-gutters">
          <article class="col-12 col-lg-10 offset-lg-1 pt-3 creator-guide">
            <p class="creator-guide__eyebrow">Creator resource</p>
            <h1>{{ guide.title }}</h1>
            <p class="creator-guide__lede">{{ guide.description }}</p>

            <section v-for="section in guide.sections" :key="section.heading" class="creator-guide__section">
              <h2>{{ section.heading }}</h2>
              <p>{{ section.body }}</p>
            </section>

            <section class="creator-guide__trust" aria-labelledby="creator-guide-trust-title">
              <h2 id="creator-guide-trust-title">Before You Publish</h2>
              <ul>
                <li>Preview the track or sound effect on Viberary.</li>
                <li>Review the visible license terms before downloading.</li>
                <li>Follow attribution instructions shown on the download page when required.</li>
                <li>Keep the track page URL with your project notes.</li>
                <li>Do not claim Viberary music as your own original composition.</li>
              </ul>
            </section>

            <nav class="creator-guide__links" aria-label="Related Viberary links">
              <router-link v-for="link in guide.links" :key="link.to" :to="link.to">{{ link.label }}</router-link>
              <router-link to="/privacy-policy">Privacy Policy</router-link>
              <router-link to="/terms-of-use">Terms of Use</router-link>
              <router-link to="/about">About Viberary</router-link>
              <router-link to="/contact-us">Contact</router-link>
            </nav>
          </article>
        </div>
      </div>
    </div>
    <SubFooter />
  </section>
</template>

<script>
import SubFooter from "../partials/SubFooter.vue";
import { creatorGuides } from '../../content/seoGrowthContent';

export default {
  components: {
    SubFooter,
  },
  computed: {
    guide() {
      return creatorGuides[this.$route.path] || creatorGuides['/free-music-for-youtube-creators'];
    }
  },
  watch: {
    '$route.path': function () {
      this.updateHead();
    }
  },
  mounted() {
    this.updateHead();
  },
  methods: {
    setMeta(selector, attribute, value) {
      const element = document.head.querySelector(selector);
      if (element) {
        element.setAttribute(attribute, value);
      }
    },
    updateHead() {
      if (!this.guide || !this.guide.title) return;
      const title = this.guide.title + ' | Viberary';
      const canonical = 'https://www.viberary.com' + this.$route.path;
      document.title = title;
      this.setMeta('meta[name="description"]', 'content', this.guide.description);
      this.setMeta('link[rel="canonical"]', 'href', canonical);
      this.setMeta('meta[property="og:title"]', 'content', title);
      this.setMeta('meta[property="og:description"]', 'content', this.guide.description);
      this.setMeta('meta[property="og:url"]', 'content', canonical);
      this.setMeta('meta[name="twitter:title"]', 'content', title);
      this.setMeta('meta[name="twitter:description"]', 'content', this.guide.description);
    }
  }
}
</script>

<style scoped>
.creator-guide {
  color: #252525;
}
.creator-guide__eyebrow {
  color: #7a6a00;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: .08em;
  margin-bottom: 8px;
  text-transform: uppercase;
}
.creator-guide h1 {
  font-size: 38px;
  line-height: 1.18;
  margin-bottom: 14px;
}
.creator-guide__lede {
  font-size: 18px;
  line-height: 1.7;
  margin-bottom: 28px;
}
.creator-guide__section,
.creator-guide__trust {
  margin-bottom: 26px;
}
.creator-guide h2 {
  font-size: 24px;
  margin-bottom: 10px;
}
.creator-guide p,
.creator-guide li {
  line-height: 1.75;
}
.creator-guide__trust {
  background: #fffdf7;
  border: 1px solid rgba(0,0,0,0.08);
  border-radius: 8px;
  padding: 18px 22px;
}
.creator-guide__links {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 24px;
}
.creator-guide__links a {
  border: 1px solid rgba(0,0,0,0.12);
  border-radius: 999px;
  color: #222;
  padding: 8px 12px;
  text-decoration: none;
}
.creator-guide__links a:hover {
  background: #ffd300;
  border-color: #ffd300;
}
@media (max-width: 767px) {
  .creator-guide h1 {
    font-size: 30px;
  }
}
</style>
